import { RootAppState } from 'store/configureStore'

export const projectDeliveryDaysSelector = (state: RootAppState) => {
  return state.project.activeProject?.estimatedDeliveryDays
}
